import { render, staticRenderFns } from "./SetPasswordForm.vue?vue&type=template&id=27ecf41b&scoped=true"
import script from "./SetPasswordForm.vue?vue&type=script&lang=js"
export * from "./SetPasswordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ecf41b",
  null
  
)

export default component.exports